import React from "react";
import { motion } from "framer-motion";
import { FiArrowUpRight, FiPhoneCall } from "react-icons/fi";
import "./AboutCTA.css";

export default function AboutCTA() {
  return (
    <section className="abcta">
      <div className="container">
        <motion.div
          className="abcta__wrap"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div className="abcta__content">
            <div className="abcta__kicker">Let’s Move Forward</div>

            <h2 className="abcta__title">
              Ready to Invest with <br /> Confidence?
            </h2>

            <p className="abcta__desc">
              Whether you’re buying your first property or planning a long-term
              investment, our team is here to guide you with clarity,
              transparency, and verified options.
            </p>

            <div className="abcta__actions">
              <a href="/projects" className="abcta__btn abcta__btn--primary">
                View Projects <FiArrowUpRight />
              </a>

              <a href="/contact" className="abcta__btn abcta__btn--ghost">
                Talk to an Advisor <FiPhoneCall />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
